<script>
export default {
  name: "viewMore"
};
</script>

<template>
  <el-row style="padding: 40px 0 20px 0; background-color: #2D2D2D">
    <el-col
      :span="24"
      style="display: flex; justify-content: center; padding: 0 16px"
    >
      <el-button class="btn-view-more" type="primary">
        View more
      </el-button>
    </el-col>
    <el-col :span="24" style="margin-top: 20px; padding: 0 16px 25px 16px;">
      <span class="content-style"
        >Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis
        suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis
        autem vel eum iure reprehenderit qui in ea voluptate velit esse quam
        nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo
        voluptas nulla pariatur?</span
      >
    </el-col>
  </el-row>
</template>

<style scoped>
.btn-view-more {
  color: #ffbe00;
  text-align: center;
  border: 3px solid #ffbe00;
  background-color: #2d2d2d;
  width: 100%;
  padding: 14px 0;
  font: 600 20px Metropolis, sans-serif;
}

.content-style {
  color: #f5f5f5;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/search/viewMore.vue